import BatchStateCard from './BatchStateCard';
import ContinueOnAppButton from './ContinueOnAppButton';
import {
  getIsBatchAccessEnded,
  getIsBatchCompleted,
  getMessageWithDate
} from '../utils';

// batch access end or batch end or continue on app button
const EnrolledBatchState = ({ batchDetails }) => {
  const { batchExpiryDate, completedAt } = batchDetails;
  const isBatchAccessEnded = getIsBatchAccessEnded(batchExpiryDate);
  const isBatchCompleted = getIsBatchCompleted(completedAt);
  if (isBatchAccessEnded) {
    return (
      <BatchStateCard
        imageUrl="prodigy/batch-end.svg"
        title="Your access to this batch has ended"
        subTitle={getMessageWithDate('Ended on', batchExpiryDate)}
        showContinueOnAppButton={false}
      />
    );
  }
  if (isBatchCompleted) {
    return (
      <BatchStateCard
        imageUrl="prodigy/batch-end.svg"
        title={getMessageWithDate('Batch ended on', completedAt)}
        subTitle={getMessageWithDate('Your access ends', batchExpiryDate)}
      />
    );
  }
  return <ContinueOnAppButton />;
};
export default EnrolledBatchState;
